import thunkMiddleware from "redux-thunk";
import { applyMiddleware, createStore } from "redux";
import { verifyAuth } from "./actions/authentication";

import rootReducer from "./reducers";

export default function configureStore(persistedState) {
  const store = createStore(
    rootReducer,
    persistedState,
    applyMiddleware(thunkMiddleware)
  );
  store.dispatch(verifyAuth());
  return store;
}
